import { render } from "./RecepcionExpress.vue?vue&type=template&id=09c7abe4&scoped=true"
import script from "./RecepcionExpress.vue?vue&type=script&lang=js"
export * from "./RecepcionExpress.vue?vue&type=script&lang=js"

import "./RecepcionExpress.vue?vue&type=style&index=0&id=09c7abe4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c7abe4"]])

export default __exports__